<template>
  <div class="mt-10">
    <h3>Transfer Recipients</h3>
    <v-data-table
      title="Transfer Recipients"
      :items="transaction.bulk_transfer_recipient_details"
      :headers="headers"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ["transaction"],
  data() {
    return {
      headers: this.pairTableLabelWithValue({
        "First Name": "last_name",
        "Last Name": "first_name",
        Email: "email",
        Country: "country",
        "Phone Number": "phone_number",
        "Amount In euros": "amount_in_euros",
        "Amount in Danacoin": "amount_in_danacoin",
        "Local Amount": "local_amount",
      }),
    };
  },
};
</script>
